/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import moment from 'moment';
import Key from '../clientVariables.json';

import { connect } from 'react-redux';

import { showLoader } from '../constant/loader.action';
import { hideLoader } from '../constant/loader.action';

function Jobs24Hours(props) {
  const location = useLocation();

  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    props.showLoader();

    var companyname = location.state.title;
    fetch(`${Key.domain}/company/get_company_jobs_24hours/${companyname}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(async (response) => {
      response.json().then(async (resdata) => {
        setJobs(resdata.data);
        console.log(response);
      });

      props.hideLoader();
    });
  };

  const columns = [
    {
      name: 'id',
      label: 'Job ID',
      options: {
        filter: true,
        sort: false,

        customBodyRender: (value, tableMeta, updateValue) => {
          return <p style={{ cursor: 'pointer' }}>{value}</p>;
        },
      },
    },
    {
      name: 'title',
      label: 'Job Title',
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <p style={{ cursor: 'pointer' }}>{value}</p>;
        },
      },
    },
    {
      name: 'modified',
      label: 'Modified Date',
      options: {
        filter: true,
        sort: false,

        customBodyRender: (value, tableMeta, updateValue) => {
          return moment(value).format('MMM DD, YYYY HH:mm A');
        },
      },
    },
  ];

  const options = {
    fixedHeader: true,
    density: true,
    selectableRows: false,
    search: true,
    filter: true,
    sort: false,
    download: true,
    print: false,
    viewColumns: false,
    rowsPerPage: 20,
    rowsPerPageOptions: [20, 50, 100],

    onCellClick: (cellIndex, rowIndex) => {
      var row = jobs[rowIndex.dataIndex];
      const url = `${Key.JNP_URL}/job/view/Job_${row.id}`;
      const pdfWindow = window.open();
      pdfWindow.location.href = url;
    },
  };

  return (
    <div className="container" style={{ paddingTop: '38px' }}>
      <MUIDataTable title={location.state.title} data={jobs} columns={columns} options={options} />

      <br />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader()),
  };
};

function mapStateToProps(state, ownProps) {
  return {
    currentUser: state.UserReducer.user,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Jobs24Hours);
